import { XpoBrowserClassification } from './browser-classification.model';

export class XpoBrowserRestrictions {
  blocked: XpoBrowserClassification[];
  suggestions?: XpoBrowserClassification[];
}
